require('./aggregatorCredentialsPSD2Styles.scss')

// @ vendors
import React, { Component } from 'react';
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import AggregatorPSD2Token from './aggregatorPSD2Token';

// @utilities
const { formatText } = require('core/i18n').i18n;
import getBreadCrumbSettings from 'utilities/aggregator/getRenewTokenBreadCrumbSettings';

class AggregatorCredentialsPSD2Token extends Component {

    continueFlowCallback = areCredentialsOk => {
        areCredentialsOk ?
            this.props.history.push('/myprofile/global/entities/renew-token/ok') :
            this.props.history.push('/myprofile/global/entities/renew-token/ko')
    }

    render() {
        return (
            <AggregatorAddEntityLayout
                title={formatText('aggregatorAddEntity-renewSessionLayoutTitle')}
                breadCrumb={getBreadCrumbSettings()}
            >
                <AggregatorPSD2Token
                    continueFlowCallback={(areCredentialsOk) =>  this.continueFlowCallback(areCredentialsOk)}
                />
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorCredentialsPSD2Token.propTypes = {
    history: PropTypes.object.isRequired,
}
export default withRouter(AggregatorCredentialsPSD2Token)
